import 'core-js/stable'; // polyfills for ECMAScript up to 2020
import 'regenerator-runtime/runtime'; // Standalone runtime for Regenerator-compiled generator and async functions
import '../../exposeVendorCore'; // Expose jQuery and Bootstrap JS globally for use outside of the KO bound element

import ko from 'knockout';
import '../../knockoutBindingProvider';
import contextData from '../contextData';
import appealDetailsConfig from './appealDetailsConfig';
import AppealDetailsViewModel from './appealDetailsViewModel';
import logger from '../../Vendor/inv-logger/logger';
import resourceHelper from '../../Vendor/inv-resource-helper/resourceHelper';
import commonBindings from '../../Vendor/inv-common-bindings/commonBindings';
import resourceDataRepository from '../Repositories/resourceDataRepository';
import systemSettingsRepository from '../Repositories/systemSettingsRepository';
import validationRulesRepository from '../Repositories/validationRulesRepository';
import ComponentRegistration from '../componentRegistration';
import '../Bindings/fadeInBinding';
import '../Bindings/recaptchaBinding';

// Use the language code defined by the lang attribute on the html tag
var languageCode = document.getElementsByTagName('html')[0].getAttribute('lang');
contextData.languageCode = languageCode;

retrieveAndPersistPortalSettings()
  .then(retrieveResponseValidationRules)
  .then(retrieveAndPersistResourceData)
  .then(function () {

    commonBindings.init(languageCode);
    logger.init(contextData.languageCode);
    ComponentRegistration.registerAllComponents();
    applyBindings();
    consoleLogInfo(contextData.portalSettings, languageCode);
  })
  .catch(function (ex) {
    logger.logAndThrowUntranslatedError(
      'An unexpected error occurred loading the site. Please try again later.',
      'Please review the error and determine if this needs to specifically be caught', ex);
  });

function retrieveAndPersistPortalSettings() {
  return systemSettingsRepository.getPortalSettings()
    .then(function (portalSettings) {
      contextData.inReleaseMode = portalSettings.inReleaseMode;
      contextData.portalSettings = portalSettings;
    })
    .catch(function (jqXhr) {

      logger.logAndThrowUntranslatedError(
        'An error occurred loading the site. Please try again later.',
        'Unable to get the system portal settings',
        jqXhr);

      return Promise.reject(jqXhr);
    });
}

function retrieveResponseValidationRules() {

  return validationRulesRepository.getValidationRules('response')
    .then(function (validationRules) {
      contextData.responseValidationRules = validationRules;
    })
    .catch(function (jqXhr) {

      logger.logAndThrowUntranslatedError(
        'An error occurred loading the site. Please try again later.',
        'Unable to get the response validation rules',
        jqXhr);

      return Promise.reject(jqXhr);
    });
}

function retrieveAndPersistResourceData() {
  return resourceDataRepository.getResourceData(contextData.languageCode)
    .then(function (resourceData) {

      // Initialize the resource helper with the main portal translations
      resourceHelper.init(resourceData);
    })
    .catch(function (jqXhr) {

      // As an error occurred retrieving the translated text, all we can do here is display error in English
      logger.logAndThrowUntranslatedError(
        'An error occurred loading the site. Please try again later.',
        'Unable to get the resource data / translated text',
        jqXhr);

      return Promise.reject(jqXhr);
    });
}

function applyBindings() {

  var params = {
    appealPublicReference: appealDetailsConfig.appealPublicReference
  };

  // The appeal page is server rendered so just bind Knockout to the dynamic content element
  ko.applyBindings(
    new AppealDetailsViewModel(params),
    document.getElementById('knockoutBoundElement'));
}

function consoleLogInfo(portalSettings, languageCode) {

  console.log('Thanks for visiting!');
  console.log('Version:', portalSettings.versionNumber);

  console.log('In release mode:', portalSettings.inReleaseMode);
  console.log('Language code:', languageCode);
}
